export const SERVICE = 'HOME'
